import requisicaoSegura from '@/auth/requisicaoSegura';
import {
  APIResponseListagemAssinaturasManuais,
  APIResponseListagemGastosMensais,
  APIResponseRecuperarAssinaturaManualUsuario,
} from '../types/assinatura';
import requestFirebase from '@/config/firebaseConfig';
import { PlataformaStreaming } from '@/types/plataformaStreaming';
import { APIResponse } from '../types';
import {
  APIFilterRecuperarConteudosNaoVistosStreaming,
  APIResponseRecuperarConteudosNaoVistosStreaming,
  FormCadastrarAssinaturaRequest,
} from './types/cadastro_assinatura';
import { AssinaturaPedido } from '../types/pedidos';
import { AssinaturaManualResumida } from '@/types/assinaturaManual';
import { listarMinhasAssinaturas } from '../pedidos';
import { api } from '@/config/axiosConfig';

export async function recuperarAssinaturasManuais(): Promise<APIResponseListagemAssinaturasManuais> {
  const responseRecuperarAssinaturaManuais: APIResponseListagemAssinaturasManuais =
    await requisicaoSegura({
      endpoint: '/Usuario/ListarPlataformaPlano',
      dataForm: {
        pagina: 0,
        paginacao: -1,
      },
    });

  return responseRecuperarAssinaturaManuais;
}

export async function recuperarGastosMensal({
  ano,
  mes,
}: {
  ano: number;
  mes: number;
}): Promise<APIResponseListagemGastosMensais> {
  const responseRecuperarAssinaturaManuais: APIResponseListagemGastosMensais =
    await requisicaoSegura({
      endpoint: '/Usuario/BuscarDadosMensais',
      dataForm: {
        mes,
        ano,
      },
    });

  return responseRecuperarAssinaturaManuais;
}

export async function recuperarPlataformasStreaming(): Promise<
  PlataformaStreaming[]
> {
  const plataformasStreaming = await requestFirebase<PlataformaStreaming[]>({
    colecao: 'plataformaStreaming',
    filtros: [
      ['ativo', '==', true],
      ['paisID', '==', '55'],
      ['permiteAssinatura', '==', true],
    ],
  });

  return plataformasStreaming;
}

export async function cadastrarAssinaturaUsuario(
  formCadastrarAssinaturaRequest: FormCadastrarAssinaturaRequest,
): Promise<APIResponse> {
  const responseCadastrarAssinatura: APIResponse = await requisicaoSegura({
    endpoint: '/Usuario/SalvarPlataformaPlano',
    dataForm: formCadastrarAssinaturaRequest,
  });

  return responseCadastrarAssinatura;
}

export async function recuperarAssinaturaManualUsuario(
  idAssinaturaManual: string,
): Promise<APIResponseRecuperarAssinaturaManualUsuario> {
  const responseRecuperarAssinaturaManualUsuario: APIResponseRecuperarAssinaturaManualUsuario =
    await requisicaoSegura({
      endpoint: '/Usuario/SelecionarPlataformaPlano',
      dataForm: { id: idAssinaturaManual },
    });

  return responseRecuperarAssinaturaManualUsuario;
}

export async function deletarAssinaturaManualUsuario(
  idAssinaturaManual: string,
): Promise<APIResponse> {
  const responseDeletarAssinaturaManualUsuario: APIResponseRecuperarAssinaturaManualUsuario =
    await requisicaoSegura({
      endpoint: '/Usuario/ExcluirPlataformaPlano',
      dataForm: { id: idAssinaturaManual },
    });

  return responseDeletarAssinaturaManualUsuario;
}

export async function recuperarConteudosNaoVistosStreaming({
  paginacao = 12,
  pagina = 1,
  plataformaStreamingID,
  filtroBusca,
  ordenacaoCampo = 'dataLancamento',
  ordenacaoOrdem = 'desc',
  modoVisualizacao = 'authenticated',
}: APIFilterRecuperarConteudosNaoVistosStreaming): Promise<APIResponseRecuperarConteudosNaoVistosStreaming> {
  const filtros = `ativo == true ${filtroBusca?.length ? `&& titulo.Contains("${filtroBusca}")` : ''}`;

  const dataForm = {
    plataformaStreamingID,
    filtros,
    pagina,
    paginacao,
    ordenacaoCampo,
    ordenacaoOrdem,
  };

  if (modoVisualizacao !== 'authenticated') {
    const formDados = new FormData();

    Object.entries(dataForm).forEach(([chave, valor]) => {
      formDados.append(chave, String(valor));
    });

    const response =
      await api.post<APIResponseRecuperarConteudosNaoVistosStreaming>(
        '/Usuario/CatalogoNaoVi',
        formDados,
        {
          headers: {
            'x-token': process.env.NEXT_PUBLIC_USUARIO_VISUALIZACAO_FILMES!,
          },
        },
      );

    return response.data;
  }

  const response: APIResponseRecuperarConteudosNaoVistosStreaming =
    await requisicaoSegura({
      endpoint: '/Usuario/CatalogoNaoVi',
      dataForm,
    });

  return response;
}

export async function registraConteudosAssistidosStreaming({
  plataformaStreamingID,
  tituloIDs,
}: {
  plataformaStreamingID: string;
  tituloIDs: string[];
}): Promise<APIResponse> {
  const formRegistrarFilmesVistos: { [key: string]: string | number } = {
    plataformaStreamingID,
  };
  tituloIDs.forEach((tituloID: string, index: number) => {
    formRegistrarFilmesVistos[`tituloIDs[${index}]`] = tituloID;
  });

  const responseRegistrarConteudosAssistidos: APIResponse =
    await requisicaoSegura({
      endpoint: '/Usuario/JaVi',
      dataForm: formRegistrarFilmesVistos,
    });

  return responseRegistrarConteudosAssistidos;
}

export async function recuperarAssinaturasNaoContratadasPeloUsuario(): Promise<
  AssinaturaManualResumida[]
> {
  const assinaturas = await recuperarAssinaturasManuais();

  const assinaturasUsuario: AssinaturaManualResumida[] =
    assinaturas?.dados?.lista ?? [];

  const hoje = new Date();
  hoje.setHours(23, 59, 59, 999);

  const retornoListarAssinaturasRealizadasPeloUsuario =
    await listarMinhasAssinaturas({
      filtros: `(statusID == 2 || (statusID == 3 && dataTermino >= DateTime(${hoje.getFullYear()}, ${hoje.getMonth() + 1}, ${hoje.getDate()}, 23, 59, 59))) && categoriaID.Equals("E21C1DA1-CF0A-4E4C-8F57-F78182B6DF4E")`,
    });

  const {
    dados: { lista: assinaturasRealizadas },
  } = retornoListarAssinaturasRealizadasPeloUsuario;

  const mapaRealizadas = new Map(
    assinaturasRealizadas.map((item: AssinaturaPedido) => [
      item.plataformaStreamingID,
      item,
    ]),
  );

  const mesclagemAssinaturasRealizadasComAssinaturasManuais: AssinaturaManualResumida[] =
    [];

  mapaRealizadas.forEach((item: AssinaturaPedido) => {
    mesclagemAssinaturasRealizadasComAssinaturasManuais.push({
      usuarioPlataformaStreamingPlanoID: undefined,
      marketplaceAssinaturaID: item.marketplaceAssinaturaID,
      usuarioID: '',
      dataCadastro: item.dataCadastro,
      meses: 1,
      nome: item.combo,
      valor: item.valor,
      plataformaStreamingPlanoID: item.marketplacePlanoID,
      plataformaStreamingID: item?.plataformaStreamingID,
      plataformaStreaming: {
        id: item?.plataformaStreamingID,
        tipo: '',
        logoArquivo: {
          urlx3: item?.plataformaStreaming?.logoUrl,
          urlx2: item?.plataformaStreaming?.logoUrl,
          arquivoID: '',
          url: item?.plataformaStreaming?.logoUrl,
          urlx1: item?.plataformaStreaming?.logoUrl,
          tipo: '',
          nomeArquivo: '',
        },
        lingua: '',
        apresentar: true,
        site: '',
        paisID: '',
        mostrarBusca: true,
        plataformaStreamingID: '',
        ativo: true,
        nome: item.combo,
        logoUrl: item?.plataformaStreaming?.logoUrl,
        logoArquivoID: '',
        descricao: '',
        planos: undefined,
      },
    });
  });

  assinaturasUsuario.forEach((manual) => {
    const plataformaID = manual.plataformaStreamingID;
    if (!plataformaID) {
      mesclagemAssinaturasRealizadasComAssinaturasManuais.push(manual);
      return;
    }

    const jaExisteNasAssinaturasRealizada = mapaRealizadas.has(plataformaID);
    if (!jaExisteNasAssinaturasRealizada) {
      mesclagemAssinaturasRealizadasComAssinaturasManuais.push(manual);
    }
  });

  return mesclagemAssinaturasRealizadasComAssinaturasManuais;
}
